module.exports = __webpack_public_path__ + "static/media/background.8f6f52ac.png";